<script>
	export let color = "#999";
	export let width = 2;
	export let size = 20;
	export let type = "";
</script>

<svg
	class="UIIcon {$$props.class || ''}"
	xmlns="http://www.w3.org/2000/svg"
	width={size}
	height={size}
	viewBox="0 0 24 24"
	style="stroke:{color}; stroke-width:{width}px"
>
	{#if type === "menu"}
		<line x1="3" y1="12" x2="21" y2="12" /><line
			x1="3"
			y1="6"
			x2="21"
			y2="6"
		/><line x1="3" y1="18" x2="21" y2="18" />
	{:else if type === "right"}
		<path d="M8 20l8-8-8-8" />
	{:else if type === "left"}
		<path d="M16 20l-8-8 8-8" />
	{:else if type === "up"}
		<path d="M20 16l-8-8-8 8" />
	{:else if type === "down"}
		<path d="M6 9l6 6 6-6" />
	{:else if type === "file"}
		<path
			d="M13 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V9l-7-7z"
		/><path d="M13 3v6h6" />
	{:else if type === "site"}
		<path
			d="M18 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2h5M15 3h6v6M10 14L20.2 3.8"
		/>
	{:else if type === "search"}
		<circle cx="11" cy="11" r="8" /><line
			x1="21"
			y1="21"
			x2="16.65"
			y2="16.65"
		/>
	{:else if type === "arrow"}
		<path d="M5 12h13M12 5l7 7-7 7" />
	{:else if type === "cross"}
		<line x1="20" y1="4" x2="4" y2="20" /><line
			x1="4"
			y1="4"
			x2="20"
			y2="20"
		/>
	{:else if type === "plus"}
		<line x1="12" y1="5" x2="12" y2="19" /><line
			x1="5"
			y1="12"
			x2="19"
			y2="12"
		/>
	{:else if type === "clear"}
		<circle cx="12" cy="12" r="10" style="fill:#aaa;" /><line
			x1="15"
			y1="9"
			x2="9"
			y2="15"
		/><line x1="9" y1="9" x2="15" y2="15" />
	{/if}
</svg>

<style global>
	.UIIcon {
		display: inline-block;
		line-height: 1;
		fill: none;
	}
</style>
